import { ref } from 'vue';
import RealEstateCommissionInstallmentsAPI from 'dashboard/api/realEstateCommissionInstallments';

export function useSalesCommissionSheetDownload({ t }) {
  const downloadingId = ref(null);
  const error = ref('');

  const download = async ({ installmentId, artifactId, filename }) => {
    const requestId = artifactId || installmentId;
    if (!requestId || downloadingId.value) return null;

    downloadingId.value = requestId;
    error.value = '';
    try {
      const response = artifactId
        ? await RealEstateCommissionInstallmentsAPI.downloadArtifact(
            installmentId,
            artifactId
          )
        : await RealEstateCommissionInstallmentsAPI.download(installmentId);
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename || `planilha-comissao-${installmentId}.pdf`;
      link.click();
      window.URL.revokeObjectURL(url);
      return true;
    } catch {
      error.value = t('SALES.DETAIL.COMMISSION.SHEETS.DOWNLOAD_ERROR');
      return null;
    } finally {
      downloadingId.value = null;
    }
  };

  return { download, downloadingId, error };
}
